<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
></app-header>
<section
    (click)="closeMegaMenuCondition(); mainCloseDropDown()"
    class="sme-new-app tw-pb-[45px] tw-bg-gradient-to-b tw-from-[#FFFBF8] tw-to-[40%] tw-to-[#F9F9F9]"
>
    <div class="sme-container">
        <app-application-stepper [value]="value" [productName]="productName"></app-application-stepper>
        <mat-divider></mat-divider>
        <!--DESKTOP-->
        <div
            class="tw-hidden xl:tw-flex tw-flex-col tw-items-start tw-gap-[10px]"
        >
            <div class="tw-flex tw-flex-col tw-gap-[10px] xl:tw-mx-[45px]">
                <span
                    class="tw-font-bold tw-text-[#7B7575] tw-text-lg"
                    *ngIf="productName"
                >
                    {{ "NEW_APPLICATION.YOU_ARE_APPLYING_FOR" | translate }}
                </span>
                <div
                    class="tw-bg-[#E3E8EC] tw-w-auto tw-text-center tw-p-[16px] tw-rounded-[16px]"
                    *ngIf="productName"
                >
                    <span
                        class="md:tw-text-2xl tw-font-semibold tw-text-[#003A70]"
                    >
                        {{ productName }}
                    </span>
                </div>
            </div>
            <h3
                class="md:tw-max-w-[100%] tw-w-[100%] tw-pt-[10%] md:tw-pt-0"
                *ngIf="!productName"
            >
                <span
                    class="tw-font-bold tw-mx-0 md:tw-mx-[70px] xl:tw-mx-0 xl:tw-px-[45px]"
                    >{{
                        "NEW_APPLICATION.FINANCIAL_PRODUCTS" | translate
                    }}</span
                >
            </h3>
        </div>
        <!--DESKTOP-->

        <!--MOBILE-->
        <div
            class="tw-flex xl:tw-hidden tw-grid tw-items-center tw-grid-cols-1 xl:tw-grid-cols-[calc(100%_-_310px),300px] tw-gap-[10px] tw-pt-[40px] md:tw-pt-[10px] md:tw-mt-3 md:tw-pb-[10px] tw-mx-0 md:tw-mx-[80px] xl:tw-mx-0"
        >
            <div class="tw-flex tw-flex-col tw-gap-[12px]">
                <mat-card
                    class="cardCSS"
                    appearance="outlined"
                    *ngIf="productName"
                >
                    <mat-card-content>
                        <div class="tw-flex tw-flex-col tw-gap-[15px]">
                            <div
                                class="tw-font-[500] tw-text-[#6B6B6B] tw-text-[16px] tw-text-center"
                            >
                                {{
                                    "NEW_APPLICATION.YOU_ARE_APPLYING_FOR"
                                        | translate
                                }}
                            </div>
                            <div
                                class="tw-bg-[#E3E8EC] tw-p-[16px] tw-rounded-[16px] tw-text-center"
                            >
                                <span
                                    class="tw-text-[14px] tw-leading-[16.8px] tw-font-[700] tw-text-[#003A70]"
                                >
                                    {{ productName }}
                                </span>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
                <ngx-slick-carousel
                    class="carousel"
                    #slickModal="slick-carousel"
                    [config]="slideConfig"
                    (afterChange)="afterChange($event)"
                    (beforeChange)="beforeChange($event)"
                >
                    <div
                        ngxSlickItem
                        *ngFor="let i of rightSide; let index = index"
                    >
                        <div
                            class="tw-relative tw-w-full tw-h-auto tw-overflow-hidden tw-rounded-lg md:tw-rounded-2xl"
                        >
                            <mat-card class="cardCSS" appearance="outlined">
                                <mat-card-content>
                                    <div
                                        class="tw-flex tw-flex-col tw-gap-[10px] mat-divider-carousel"
                                    >
                                        <div
                                            class="tw-flex tw-flex-row tw-gap-[14px] tw-mt-[1%] tw-mb-[2%]"
                                        >
                                            <img
                                                *ngIf="index == 0"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/preliminary.png"
                                                alt="preliminary"
                                            />
                                            <img
                                                *ngIf="index == 1"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/expand_circle_right.png"
                                                alt="expand_circle_right"
                                            />
                                            <img
                                                *ngIf="index == 2"
                                                class="tw-w-[45px] tw-h-[45px]"
                                                src="/assets/images/done.png"
                                                alt="done"
                                            />
                                            <div
                                                class="tw-font-semibold tw-leadng-[21.6px] tw-text-[18px] tw-m-auto"
                                            >
                                                {{ i.title | translate }}
                                            </div>
                                        </div>
                                        <mat-divider
                                            class="small"
                                        ></mat-divider>
                                        <div
                                            class="tw-font-medium tw-leading-[24px] tw-text-[16px] tw-mb-[14px] tw-my-[2%]"
                                        >
                                            {{ i.subtitle | translate }}
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
        <!--MOBILE-->

        <financial-info
            [close]="clickedOutsideDD"
            [productName]="productName"
        ></financial-info>
    </div>
</section>

<app-footer (click)="closeMegaMenuCondition()"></app-footer>
